import { DateSectionContent, EyeTestTimeSlot } from "@/common/lib/types";
import { FC } from "react";
import TimeSlot from "./components/TimeSlot";
import DatePicker from "@/components/ui/datePicker/DatePicker";
import { cn } from "@/lib/tailwind";
import LoaderGif from "@/assets/gif/preloader.gif";
import Image from "next/image";
import Button from "@/components/ui/button/Button";

interface EyeTestDateViewProps {
  content?: DateSectionContent;
  slots?: EyeTestTimeSlot[];
  selectedDate: Date | null;
  selectedTimeSlot?: EyeTestTimeSlot;
  holidays?: Date[];
  slotLoading: boolean;
  onDateChange: (date: Date | null) => void;
  onSlotChange: (slot: EyeTestTimeSlot) => void;
  onSubmit: () => void;
  onMonthChange?: (date: Date) => void;
  isLoading: boolean;
}

const EyeTestDateView: FC<EyeTestDateViewProps> = (props) => {
  const {
    isLoading,
    content,
    slots,
    slotLoading,
    selectedDate,
    selectedTimeSlot,
    holidays,
    onDateChange,
    onSlotChange,
    onSubmit,
    onMonthChange,
  } = props;

  return (
    <div className="w-full md:px-10">
      <div className="w-full">
        <DatePicker
          selected={selectedDate}
          minDate={new Date()}
          holidays={holidays}
          onChange={(date) => onDateChange(date)}
          onMonthChange={onMonthChange}
        />
      </div>
      <div className="mt-12 w-full px-4">
        <div className="grid grid-cols-12">
          <p className="col-span-full mb-5 font-bold">{content?.timeSlotsLabel}</p>
        </div>
        <div className="grid w-full grid-cols-12 gap-4 lg:grid-cols-10">
          {slotLoading ? (
            <div className="col-span-full flex h-10 items-center justify-center p-16">
              <Image src={LoaderGif} height={72} width={72} alt="loading" />
            </div>
          ) : Array.isArray(slots) && slots?.length > 0 ? (
            slots.map((slot) => (
              <TimeSlot
                key={slot.start}
                slot={slot}
                selectedTimeSlot={selectedTimeSlot}
                onChange={onSlotChange}
              />
            ))
          ) : (
            <p className="col-span-full w-full">{content?.noSlotsAvailable}</p>
          )}
        </div>
      </div>
      <div className="mt-12 w-full px-4">
        <Button
          className={cn(
            "flex h-12 w-full items-center justify-center bg-black px-2 text-center text-[0.813rem] text-white md:p-0 md:px-3",
            !(selectedDate && selectedTimeSlot) && "bg-[#C4C4C4]",
          )}
          onClick={onSubmit}
          disabled={!(selectedDate && selectedTimeSlot)}
          isLoading={isLoading}
        >
          {content?.continueButtonLabel}
        </Button>
      </div>
    </div>
  );
};

export default EyeTestDateView;
